import React from 'react';
import { useIntl } from 'react-intl';
import Row from '@amzn/meridian/row';
import Tag from '@amzn/meridian/tag';
import {
  FilterValue,
  FilterKeyType,
  UniversalFilterValue,
  FilterValues,
  FilterKey,
} from '../types/types';
import { getFilterDisplay } from '../displayString';

export interface ActiveFilterTagsProps {
  activeFilters: Partial<FilterValues>;
  onRemoveFilter: (filterKey: FilterKeyType) => void;
}

export const ActiveFilterTags: React.FC<ActiveFilterTagsProps> = ({
  activeFilters,
  onRemoveFilter,
}) => {
  const intl = useIntl();

  const shouldDisplayFilter = (
    key: FilterKeyType,
    value: FilterValue
  ): boolean => {
    return (
      value !== undefined &&
      value !== UniversalFilterValue.ALL &&
      key !== FilterKey.VIEW_DATA_BY &&
      key !== FilterKey.TIME_OPTIONS &&
      key !== FilterKey.TM
    );
  };

  const getFormattedLabel = (
    key: FilterKeyType,
    value: FilterValue
  ): string => {
    const translation = getFilterDisplay(key, value);

    const filterPrefix = intl.formatMessage({
      id: translation.prefix.id,
      defaultMessage: translation.prefix.defaultMessage,
    });

    const valueText = intl.formatMessage(
      {
        id: translation.value.id,
        defaultMessage: translation.value.defaultMessage,
      },
      translation.value.values
    );

    return intl.formatMessage(
      {
        id: 'cs_perfportal_filter_format',
        defaultMessage: '{filterPrefix}: {value}',
      },
      {
        filterPrefix,
        value: valueText,
      }
    );
  };

  return (
    <Row spacing='200' alignmentVertical='center'>
      {(Object.entries(activeFilters) as [FilterKeyType, FilterValue][]).map(
        ([key, value]) => {
          if (shouldDisplayFilter(key, value)) {
            return (
              <Tag
                key={key}
                onClose={() => onRemoveFilter(key)}
                data-testid={`filter-tag-${key}`}
              >
                {getFormattedLabel(key, value)}
              </Tag>
            );
          }
          return null;
        }
      )}
    </Row>
  );
};

export default ActiveFilterTags;
